module.exports = "<div class=\"md-modal\" [ngClass]=\"modalClass\" id=\"{{modalID}}\">\n  <div class=\"md-content\" [ngClass]=\"contentClass\">\n    <ng-content></ng-content>\n  </div>\n</div>\n<div *ngIf=\"(backDrop); else: backDropOver\" class=\"md-overlay\"></div>\n<ng-template #backDropOver>\n  <div class=\"md-overlay\" (click)=\"close(modalID)\"></div>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal-animation/modal-animation.component.html
// module id = ./src/app/shared/modal-animation/modal-animation.component.html
// module chunks = main